import { SearchResult } from '@/components/misc/GlobalSearch/types'
import { PANEL_INVITE_MODAL_SEARCH_PARAMS } from '@/components/modals/PanelInviteModal/hooks/usePanelInviteModal'
import { buildUrl } from '@/lib/helpers/helperFunctions'
import { currentUrl } from '@/lib/helpers/routeHelpers'
import {
  PanelInviteCompanySearchResult,
  RegisteredCompanySearchResult,
  UnregisteredCompanySearchResult,
} from '@/types/responses/companies'

class GlobalSearchService {
  isRegisteredCompany(
    searchResult: SearchResult,
  ): searchResult is RegisteredCompanySearchResult {
    return 'presentationName' in searchResult
  }

  isUnregisteredCompany(
    searchResult: SearchResult,
  ): searchResult is UnregisteredCompanySearchResult {
    return 'name' in searchResult
  }

  isPanelInviteCompany(
    searchResult: SearchResult,
  ): searchResult is PanelInviteCompanySearchResult {
    return 'companyName' in searchResult
  }

  getCompanyUrl(result: SearchResult): string {
    if (
      globalSearchService.isRegisteredCompany(result) ||
      globalSearchService.isUnregisteredCompany(result)
    ) {
      if (!result.frontendIdentifier || !result.frontendIdentifierType) {
        throw new Error(
          'Expected both result.frontendIdentifier and result.frontendIdentifierType to be set',
        )
      }

      return buildUrl(currentUrl(), {
        searchParams: {
          identifier: result.frontendIdentifier,
          identifierType: result.frontendIdentifierType,
        },
      })
    }

    return buildUrl(currentUrl(), {
      [PANEL_INVITE_MODAL_SEARCH_PARAMS.source]: result.source,
      [PANEL_INVITE_MODAL_SEARCH_PARAMS.sourceId]: result.sourceId,
    })
  }
}

const globalSearchService = new GlobalSearchService()

export default globalSearchService
